var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-almost-done"
  }, [_c('h3', {
    staticClass: "ugc-almost-done-title text-center"
  }, [_vm._v("\n    " + _vm._s(_vm.translations.ugcInterModalHeader) + "\n  ")]), _c('div', {
    staticClass: "row"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showOnRepositionWarning,
      expression: "!showOnRepositionWarning"
    }],
    class: ['ugc-almost-done-text colums small-8 small-centered', _vm.enableNewUgcModal ? 'medium-7' : 'medium-5']
  }, [_vm._v("\n      " + _vm._s(_vm.activeUGCIndex === 0 ? _vm.translations.ugcInterModalDesc1 : _vm.translations.modals.addYourImageGallery.addYourImageGalleryAlmostDoneDesc) + " " + _vm._s(_vm.nextUGCComponentDisplayName) + "\n      " + _vm._s(_vm.translations.ugcInterModalDesc2) + ".\n\n      "), _c('v-popover', {
    staticClass: "ugc-almost-done-popover",
    attrs: {
      "placement": "top",
      "trigger": "hover click",
      "popoverClass": "ugc-almost-done-v-popover"
    }
  }, [_c('span', {
    staticClass: "icon-help ugc-help-icon"
  }), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "ugc-almost-done-popover-content"
  }, [_c('img', {
    attrs: {
      "src": _vm.placementPopoverImageUrl
    }
  })])])], 2)], 1), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showOnRepositionWarning,
      expression: "showOnRepositionWarning"
    }],
    class: ['ugc-almost-done-text-warning colums small-8 small-centered', _vm.enableNewUgcModal ? 'medium-7' : 'medium-5']
  }, [_vm._v("\n      " + _vm._s(_vm.translations.ugcInterModalWarningText) + " " + _vm._s(_vm.nextUGCComponentDisplayName) + "\n      " + _vm._s(_vm.translations.ugcInterModalWarningText2) + ".\n    ")])]), _c('div', {
    staticClass: "row ugc-almost-done-cta-wrapper"
  }, [!_vm.isSecondaryImage && _vm.activeUGCIndex === 0 && !_vm.isRepositionWarningFlowActive ? _c('button', {
    class: ['secondary button colums small-8 small-centered', _vm.enableNewUgcModal ? 'medium-7' : 'medium-5'],
    on: {
      "click": _vm.onUploadAnotherClick
    }
  }, [_vm._v("\n      " + _vm._s(_vm.translations.ugcInterModalUploadAnother) + "\n    ")]) : _vm._e(), !_vm.isSecondaryImage && _vm.activeUGCIndex === 1 && !_vm.isRepositionWarningFlowActive ? _c('button', {
    class: ['secondary button colums small-8 small-centered', _vm.enableNewUgcModal ? 'medium-7' : 'medium-5'],
    on: {
      "click": _vm.onSelectAnotherClick
    }
  }, [_vm._v("\n      " + _vm._s(_vm.translations.modals.addYourImageGallery.addYourImageGallerySelectAnother) + "\n    ")]) : _vm._e()]), _c('div', {
    staticClass: "row ugc-almost-done-cta-wrapper"
  }, [_c('button', {
    class: ['secondary button colums small-8 small-centered', _vm.enableNewUgcModal ? 'medium-7' : 'medium-5'],
    on: {
      "click": _vm.continueSameImage
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showOnRepositionWarning,
      expression: "!showOnRepositionWarning"
    }]
  }, [_vm._v(_vm._s(_vm.activeUGCIndex === 0 ? _vm.translations.ugcInterModalSamePhoto : _vm.translations.modals.addYourImageGallery.addYourImageGalleryUseSame))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showOnRepositionWarning,
      expression: "showOnRepositionWarning"
    }]
  }, [_vm._v(_vm._s(_vm.translations.ugcInterModalRepNextComp))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showOnRepositionWarning,
      expression: "!showOnRepositionWarning"
    }],
    staticClass: "ugc-almost-done-linebreak text-center"
  }, [_c('span', {
    staticClass: "ugc-almost-done-linebreak-line"
  }), _c('span', {
    staticClass: "ugc-almost-done-linebreak-text"
  }, [_vm._v(_vm._s(_vm.translations.ugcInterModalOR))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showOnRepositionWarning,
      expression: "!showOnRepositionWarning"
    }],
    staticClass: "row"
  }, [_c('p', {
    class: ['ugc-almost-done-text colums small-8 small-centered', _vm.enableNewUgcModal ? 'medium-7' : 'medium-5']
  }, [_vm._v("\n      " + _vm._s(_vm.translations.ugcInterModalConfirmText) + "\n    ")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showOnRepositionWarning,
      expression: "!showOnRepositionWarning"
    }],
    staticClass: "row ugc-almost-done-cta-wrapper"
  }, [_c('button', {
    ref: "finishButton",
    class: ['ugc-almost-done-cta-finish primary button colums small-8 small-centered', _vm.enableNewUgcModal ? 'medium-7' : 'medium-5'],
    on: {
      "click": _vm.openConfirmDesign
    }
  }, [_vm._v("\n      " + _vm._s(_vm.translations.ugcInterModalFinish) + "\n    ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }